import {
    Box,
    Checkbox,
    Grid,
    Hidden,
    IconButton,
    Theme,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {
    BlackDownArrowIcon,
    BlueEditIcon,
    DeleteIcons,
    FundTransferArrow
} from "../assets/SvgIcons";
import SchemeCard from "./SchemeCard";
import { toINR } from "../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../redux-store/reducers";

export type PaymentItemProps = {
    orderDetails: Array<{ label: string, value: string }>;
    fromSchemeName: string;
    toSchemeName: string;
    amcId: string;
}

export default function PaymentContactDetails({ contactDetails }: { contactDetails: { name: string, mobile: string, email: string }[] }): JSX.Element {
    const theme = useTheme();
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    return (
        <Box>
            <Grid
                container
                flexWrap="nowrap"
                sx={{ columnGap: "15px" }}
            >
                <Grid
                    item
                    container
                    xs={12}
                    flexWrap="nowrap"
                    sx={{ columnGap: "15px" }}
                >
                    <Grid
                        item
                        container
                        flexDirection="column"
                        sx={{ rowGap: "10px" }}
                    >
                        <Typography
                            variant="h3"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Contact Details
                        </Typography>
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary
                            })}
                        >
                            The Otp will be sent to the below mentioned Investors and their contact details. Please verify the details before proceeding.
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ marginTop: "35px" }}>
                {contactDetails.map((obj, idx) => (
                    <Grid
                        key={idx}
                        container
                    >
                        <Grid item xs={12} sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, rowGap: "5px", justifyContent: "space-between", mb: 2 }}>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.secondary
                                    })}
                                >
                                    Name
                                </Typography>
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: '100%',
                                        ...theme.typography.body_500,
                                    })}
                                >
                                    {obj.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.secondary
                                    })}
                                >
                                    Email
                                </Typography>
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: '100%',
                                        ...theme.typography.body_500,
                                    })}
                                >
                                    {obj.email}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'flex-start', md: 'flex-end' } }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.secondary
                                    })}
                                >
                                    Mobile
                                </Typography>
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ...theme.typography.body_500,
                                    })}
                                >
                                    {obj.mobile}
                                </Typography>
                            </Grid>
                        </Grid>
                        {idx != contactDetails.length - 1 && <Grid xs={12} sx={{ borderBottom: `1px solid ${theme.palette.text.secondary}`, mb: 2 }} />}
                    </Grid>
                ))}
            </Box>
        </Box >
    )
}
